import { extractItemName } from "../utils/expenseDraftModal";
import {
  useAddExpenseSupplier,
  useReactivateExpenseSupplier,
} from "./useExpenses";
import { ExpenseDraftFormValue } from "../types/expenseDraft";
import { Supplier } from "@/types/supplier";

interface HandleOperationProps {
  values: ExpenseDraftFormValue;
  onSuccess?: (data: Supplier) => void;
  onError?: () => void;
}

export const useExpenseSupplier = () => {
  const { mutate: addExpenseSupplier } = useAddExpenseSupplier();
  const { mutate: reactivateExpenseSupplier } = useReactivateExpenseSupplier();

  const handleAddExpenseSupplier = ({
    values,
    onSuccess,
    onError,
  }: HandleOperationProps): Promise<void> => {
    const supplierName = extractItemName(values.supplier_id || "", "new-");

    return new Promise((resolve) => {
      addExpenseSupplier(
        {
          name: supplierName,
          expense_type_id: values.expense_type_id,
        },
        {
          onSuccess: (data: Supplier) => {
            onSuccess?.(data);
            resolve();
          },
          onError: () => onError?.(),
        }
      );
    });
  };

  const handleReactivateExpenseSupplier = ({
    values,
    onSuccess,
    onError,
  }: HandleOperationProps): Promise<void> => {
    const supplierId = extractItemName(values.supplier_id || "", "inactive-");

    return new Promise((resolve) => {
      reactivateExpenseSupplier(supplierId, {
        onSuccess: (data: Supplier) => {
          onSuccess?.(data);
          resolve();
        },
        onError: () => onError?.(),
      });
    });
  };
  return {
    handleAddExpenseSupplier,
    handleReactivateExpenseSupplier,
  };
};

export default useExpenseSupplier;
